module.exports = __webpack_public_path__ + "media/images/banner/5-7c7d0101a24251555c840f08ffa81330.jpg";